import React from "react";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router";
import classNames from "classnames";
import ChapterProgress from "../../../components/ChapterProgress";
import FormErrorHandler from "../../../components/FormErrorHandler";
import { scrollToElem } from "../../../functions.js";

export default class measurementMomentsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.eventTypeID !== undefined,
            errorMessage: {},
            competenceprofile: false,
            competenceprofileData: false,
            events: [],
            name: "",
            order: 0,
            description: "",
            type: "practice",
            prerequisites: [],
            parent: null,
            is_active: 0,
            roles_are_editable: true,
            possibleParents: [],
            allParents: [],
            cpEndterms: [],
            cpCompetences: {},
            cpMeasurements: {},
            openEndterms: {},
            selectedCompetences: {}
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateElementState = this.updateElementState.bind(this);
        this.filterCurrentData = this.filterCurrentData.bind(this);
        this.toggleSelectedEndterm = this.toggleSelectedEndterm.bind(this);
        this.toggleSelectedCompetence = this.toggleSelectedCompetence.bind(this);
        this.toggleOpenEndterm = this.toggleOpenEndterm.bind(this);
    }

    filterCurrentData() {
        if (this.state.competenceprofileData) {
            // First-clear the current state and prefill with selected data
            let cpEndterms = [];
            let cpCompetences = {};
            let cpMeasurements = {};
            let openEndterms = {};
            let i = 0;

            // Filter the currently selected items
            this.state.competenceprofileData.forEach((et) => {
                cpEndterms.push(et);
                openEndterms[et.uuid] = false;

                // Also make sure we get all the subselected competences and prefill the selector elements
                let newComp = [];
                et.competences.forEach((comp) => {
                    // Get all the subselected measurements as well
                    newComp.push({
                        value: comp.uuid,
                        label: comp.name
                    });

                    let newMeasurement = [];
                    comp.measurements.forEach((meas) => {
                        newMeasurement.push({
                            value: meas.uuid,
                            label: meas.name
                        });
                    });

                    cpMeasurements = {
                        ...cpMeasurements,
                        [comp.uuid]: newMeasurement
                    };
                });

                // Set the new state with these items
                cpCompetences = {
                    ...cpCompetences,
                    [et.uuid]: newComp
                };
            });

            this.setState({
                cpEndterms,
                cpCompetences,
                cpMeasurements,
                openEndterms
            });
        }
    }

    updateElementState(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        let postData = {
            order: this.state.order,
            name: this.state.name,
            parent: this.state.parent == "" ? null : this.state.parent,
            type: this.state.type,
            is_active: this.state.is_active,
            roles: [
                {
                    name: null,
                    end_terms: this.state.cpEndterms
                        .filter((et) => {
                            return et.competences.find((comp) => {
                                if (this.state.selectedCompetences[comp.uuid] && this.state.selectedCompetences[comp.uuid].status) {
                                    return true;
                                }
                                return false;
                            });
                        })
                        .map((et) => {
                            return {
                                uuid: et.uuid,
                                competences: et.competences
                                    .filter((comp) => {
                                        if (comp.is_active && this.state.selectedCompetences[comp.uuid] && this.state.selectedCompetences[comp.uuid].status) {
                                            return true;
                                        }
                                        return false;
                                    })
                                    .map((comp) => {
                                        return {
                                            uuid: comp.uuid,
                                            measurements: comp.measurements
                                                .filter((m) => m.is_active && m.type === this.state.type)
                                                .map((meas) => {
                                                    return {
                                                        uuid: meas.uuid
                                                    };
                                                })
                                        };
                                    })
                            };
                        })
                }
            ]
        };

        if (this.state.editMode && !this.state.competenceprofile.content_editable) {
            postData = {
                name: this.state.name,
                order: this.state.order,
                is_active: this.state.is_active
            };
        }

        if (this.state.type === "practice") {
            postData.prerequisites = this.state.prerequisites;
        }

        if (this.state.editMode) {
            // In case of edit item we PATCH the data
            axios
                .patch(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/`, postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `Het standaard toetsmoment '${response.data.name}' is succesvol opgeslagen`,
                        link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`
                    });
                    this.props.router.push(`/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments`);
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            // In case of new item we POST the data
            axios
                .post(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/`, postData)
                .then((response) => {
                    if (this.state.type === "knowledge") {
                        // At the first save of a knowledge type we redirect back to the current screen
                        this.props.addGlobalMessage({
                            title: `Het standaard toetsmoment '${response.data.name}' is succesvol opgeslagen`,
                            link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`
                        });
                        window.location = `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`;
                    } else {
                        this.props.addGlobalMessage({
                            title: `Het standaard toetsmoment '${response.data.name}' is succesvol opgeslagen`,
                            link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${response.data.uuid}`
                        });
                        this.props.router.push(`/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments`);
                    }
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    }

    toggleSelectedEndterm(endtermID) {
        // Toggle all the measurements below this endterm and store in the state
        let et = this.state.cpEndterms.find((et) => et.uuid === endtermID);

        // Check how many are selected
        let newState = this.state.selectedCompetences;
        const typeCompetences = et.competences.filter((comp) => comp.measurements.find((meas) => meas.type === this.state.type));

        // If all are selected, unselect all
        let newStatus = !typeCompetences.every((comp) => !comp.is_active || newState[comp.uuid]?.status || false);

        typeCompetences.forEach((comp) => {
            let compStatus = newStatus;
            if (!comp.is_active) {
                compStatus = false;
            }
            // let selectedComp = this.state.selectedCompetences[comp.uuid];
            // if (!selectedComp || selectedComp.status === false) {
            //   newStatus = true;
            // };

            if (comp.measurements.find((meas) => meas.type == this.state.type)) {
                newState[comp.uuid] = {
                    status: compStatus,
                    measurements: comp.measurements.map((meas) => ({
                        uuid: meas.uuid
                    }))
                };
            }
        });

        this.setState({
            selectedCompetences: newState
        });
    }

    toggleSelectedCompetence(endtermID, competenceID) {
        // Toggle all the measurements below this competence
        let newStatus = false;
        let et = this.state.cpEndterms.find((et) => et.uuid == endtermID);

        let selectedComp = this.state.selectedCompetences[competenceID];
        if (!selectedComp || selectedComp.status === false) {
            newStatus = true;
        }

        let newState = this.state.selectedCompetences;
        et.competences.forEach((comp) => {
            if (comp.uuid == competenceID) {
                newState[comp.uuid] = {
                    status: newStatus,
                    measurements: comp.measurements.map((meas) => {
                        return {
                            uuid: meas.uuid
                        };
                    })
                };
            }
        });
        this.setState({
            selectedCompetences: newState
        });
    }

    toggleOpenEndterm(endtermID) {
        // Show the underlying competences for this endterm
        let val = !this.state.openEndterms[endtermID];

        this.setState({
            openEndterms: {
                ...this.state.openEndterms,
                [endtermID]: val
            }
        });
    }

    componentDidMount() {
        axios
            .all([
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/"),
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/"),
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/eventtemplates/?is_parent=1&fields=uuid,name,type,parent,is_active&pagination=false"),
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/eventtemplates/?fields=uuid,name,type,parent,is_active&pagination=false")
            ])
            .then(
                axios.spread((cp, cpData, cpEventTypes, allParents) => {
                    this.setState({
                        competenceprofile: cp.data,
                        competenceprofileData: cpData.data,
                        possibleParents: cpEventTypes.data,
                        allParents: allParents.data
                    });
                    this.filterCurrentData();
                })
            );

        if (this.state.editMode) {
            axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/eventtemplates/" + this.props.params.eventTypeID + "/").then((response) => {
                let selectedCompetences = {};
                response.data.roles.forEach((role) => {
                    role.end_terms.forEach((et) => {
                        et.competences.forEach((comp) => {
                            selectedCompetences[comp.uuid] = {
                                status: true
                            };
                        });
                    });
                });

                this.setState({
                    name: response.data.name,
                    order: response.data.order,
                    prerequisites: response.data.prerequisites,
                    description: response.data.description,
                    is_active: response.data.is_active ? 1 : 0,
                    parent: response.data.parent,
                    type: response.data.type,
                    roles: response.data.roles,
                    selectedRoles: response.data.roles,
                    roles_are_editable: response.data.roles_are_editable,
                    selectedCompetences: selectedCompetences
                });
            });
        }
    }

    render() {
        let endtermRows = [];
        if (this.state.cpEndterms.length > 0) {
            this.state.cpEndterms.forEach((et) => {
                // Check if this endterm is active
                let etActive = false;
                let count = 0;

                // if we check on type of competence
                let typeCompetences = et.competences.filter((comp) => comp.is_active && comp.measurements.find((meas) => meas.type === this.state.type));

                typeCompetences.forEach((comp) => {
                    if (this.state.selectedCompetences[comp.uuid] && this.state.selectedCompetences[comp.uuid].status) {
                        etActive = true;
                        count++;
                    }
                });

                let activateItem = (
                    <i
                        className="fa fa-toggle-off"
                        title="Activeren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleSelectedEndterm(et.uuid);
                        }}
                    ></i>
                );
                if (etActive && count === typeCompetences.length) {
                    activateItem = (
                        <i
                            className="fa fa-toggle-on"
                            title="Deactiveren"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleSelectedEndterm(et.uuid);
                            }}
                        ></i>
                    );
                }

                if (typeCompetences.length > 0) {
                    // Only add endterms with more then 0 competences
                    let etClassnames = classNames("table-light", { inactive: !etActive });

                    endtermRows.push(
                        <tr key={et.uuid} className={etClassnames}>
                            <td>{et.name}</td>
                            <td>
                                {count} / {typeCompetences.length}
                            </td>
                            <td>{this.state.roles_are_editable ? activateItem : ""}</td>
                        </tr>
                    );

                    endtermRows.push(
                        <tr key={"heading" + et.uuid} className="table-light jumpin">
                            <th colSpan="2">Competentie</th>
                            <th>&nbsp; &nbsp; {this.state.roles_are_editable ? "Status" : ""}</th>
                        </tr>
                    );

                    // Check for the underlying competences and show them if endterm is open
                    let noComps = 0;
                    et.competences.forEach((comp) => {
                        if (comp.measurements.find((m) => m.type === this.state.type)) {
                            let compActivateItem = null;

                            if (comp.is_active) {
                                compActivateItem = (
                                    <i
                                        className="fa fa-toggle-off"
                                        title="Activeren"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.toggleSelectedCompetence(et.uuid, comp.uuid);
                                        }}
                                    ></i>
                                );
                                if (this.state.selectedCompetences[comp.uuid] && this.state.selectedCompetences[comp.uuid].status) {
                                    compActivateItem = (
                                        <i
                                            className="fa fa-toggle-on"
                                            title="Deactiveren"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.toggleSelectedCompetence(et.uuid, comp.uuid);
                                            }}
                                        ></i>
                                    );
                                }
                            } else {
                                compActivateItem = "-";
                            }
                            noComps++;

                            const compClassnames = classNames("table-light", "jumpin", "noborder", {
                                inactive: !comp.is_active || !(this.state.selectedCompetences[comp.uuid] && this.state.selectedCompetences[comp.uuid].status)
                            });
                            endtermRows.push(
                                <tr key={et.uuid + comp.uuid} className={compClassnames}>
                                    <td colSpan="2">
                                        {comp.name}
                                        {!comp.is_active && " (competentie niet actief)"}
                                    </td>
                                    <td>&nbsp; &nbsp;{this.state.roles_are_editable && comp.is_active ? compActivateItem : ""}</td>
                                </tr>
                            );
                        }
                    });

                    if (noComps === 0) {
                        endtermRows.push(
                            <tr key={et.uuid + "-0"} className="table-light jumpin noborder inactive">
                                <td colSpan="2">Geen competenties die aan dit type voldoen.</td>
                                <td>-</td>
                            </tr>
                        );
                    }
                }
            });

            if (endtermRows.length === 0) {
                // 0 results
                endtermRows.push(
                    <tr key="zero-results">
                        <td colSpan="3">Er zijn geen competenties voor dit type toetsmoment.</td>
                    </tr>
                );
            }
        } else {
            endtermRows.push(
                <tr key="0">
                    <td colSpan="10">Er konden geen eindtermen worden gevonden onder dit competentieprofiel</td>
                </tr>
            );
        }

        // Check the value for parent
        let parentMeasurementMoment = "";
        if (this.state.parent != null) {
            parentMeasurementMoment = this.state.parent;
        }
        let parentHTML = (
            <div>
                <select
                    tabIndex="3"
                    className="form-control form-control-md"
                    name="parent"
                    ref="parent"
                    onChange={this.updateElementState}
                    value={parentMeasurementMoment}
                    disabled={this.state.possibleParents.length == 0}
                >
                    <option value="">Nee</option>
                    {this.state.possibleParents.map((parent) => {
                        if (parent.uuid != this.props.params.eventTypeID) {
                            return (
                                <option key={parent.uuid} value={parent.uuid}>
                                    {parent.type == "practice" ? "Praktijk - " : ""}
                                    {parent.type == "knowledge" ? "Kennis - " : ""}
                                    {parent.type == "knowledge-exam" ? "Theorietoets - " : ""}
                                    {parent.type == "elearning" ? "E-learning - " : ""}
                                    {parent.name} {parent.is_active ? "" : " (inactief)"}
                                </option>
                            );
                        }
                        return false;
                    })}
                </select>
                <FormErrorHandler fieldName="parent" errorObject={this.state.errorMessage} />
            </div>
        );

        // Check if we are a parent ourselves
        let currentParents = this.state.allParents.filter((parent) => parent.parent !== null && parent.parent == this.props.params.eventTypeID);
        if (currentParents.length > 0) {
            parentHTML = (
                <div>
                    Dit standaard toetsmoment is zelf een overkoepelend toetsmoment voor:
                    <ul>
                        {this.state.allParents
                            .filter((parent) => parent.parent == this.props.params.eventTypeID)
                            .map((parent) => {
                                return (
                                    <li key={`parent-${parent.uuid}`} className={classNames({ lighter: !parent.is_active })}>
                                        {parent.name} {!parent.is_active ? "(inactief)" : ""}
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>
                        <strong>{this.state.competenceprofile.name}</strong>
                    </h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={this.state.dirtyForm}
                        activeChapter={6}
                        {...this.props}
                    />
                </div>

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="container">
                        <h2 className="form-title">Standaard toetsmoment {this.state.editMode ? "bewerken" : "toevoegen"}</h2>

                        <div className="row">
                            <div className="col-3">
                                <h3 className="form-section-title">Algemene gegevens</h3>
                            </div>
                            <div className="col-2">
                                <div className="form-group">
                                    <label>Volgorde *</label>
                                    <input
                                        tabIndex="1"
                                        type="text"
                                        name="order"
                                        ref="order"
                                        autoFocus={true}
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.order}
                                    />
                                    <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                                </div>
                            </div>
                            <div className="col-5">
                                <div className="form-group">
                                    <label>Titel *</label>
                                    <input
                                        tabIndex="2"
                                        type="text"
                                        name="name"
                                        ref="name"
                                        autoFocus={true}
                                        onChange={this.updateElementState}
                                        className="form-control form-control-md"
                                        required={true}
                                        value={this.state.name}
                                    />
                                    <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="form-group">
                                    <label>Actief</label>
                                    <select
                                        tabIndex="3"
                                        className="form-control form-control-md"
                                        name="is_active"
                                        ref="is_active"
                                        onChange={this.updateElementState}
                                        value={this.state.is_active}
                                    >
                                        <option value="1">Ja</option>
                                        <option value="0">Nee</option>
                                    </select>
                                    <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-7">
                                <div className="form-group">
                                    <label>Overkoepelend toetsmoment</label>
                                    {parentHTML}
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="form-group">
                                    <label>Type</label>
                                    <select
                                        tabIndex="4"
                                        className="form-control form-control-md"
                                        name="type"
                                        ref="type"
                                        onChange={this.updateElementState}
                                        value={this.state.type}
                                    >
                                        <option value="practice">Praktijk</option>
                                        {this.state.editMode && this.state.type === "knowledge" ? <option value="knowledge">Kennis</option> : ""}
                                        <option value="knowledge-exam">Theorietoets</option>
                                        <option value="elearning">E-learning</option>
                                    </select>
                                    <FormErrorHandler fieldName="type" errorObject={this.state.errorMessage} />
                                </div>
                            </div>
                        </div>

                        {this.state.type === "practice" ? (
                            <div className="row">
                                <div className="col-3"></div>
                                <div className="col-7">
                                    <div className="form-group">
                                        <label>Deelname aan dit toetsmoment is afhankelijk van:</label>
                                        <Select
                                            {...window.selectDefaults}
                                            key={`prerequisites-${this.props.title}`}
                                            name={"prerequisites"}
                                            value={this.state.prerequisites}
                                            isDisabled={!this.state.roles_are_editable}
                                            options={this.state.allParents
                                                .filter((item) => item.type === "elearning" && item.is_active)
                                                .map((item) => {
                                                    return {
                                                        value: item.uuid,
                                                        label: item.name
                                                    };
                                                })}
                                            onChange={(value) => {
                                                this.setState({
                                                    prerequisites: value.map((value) => value.value)
                                                });
                                            }}
                                            multi={true}
                                        />
                                        <FormErrorHandler fieldName="prerequisites" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            false
                        )}

                        <div className="row">
                            <div className="col-3">
                                <h3 className="form-section-title">Eindtermen</h3>
                            </div>
                            <div className="col-9">
                                <div className="form-group">
                                    <label>Beheer hieronder de eindtermen en competenties voor dit toetsmoment</label>
                                    {!this.state.roles_are_editable ? (
                                        <div className="alert alert-danger">
                                            Je kunt de onderstaande gegevens van dit standaard toetsmoment niet veranderen of bijwerken omdat er al toetsmomenten op basis
                                            hiervan zijn aangemaakt.
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>

                                <table className="table table-hover table-clickable">
                                    <thead>
                                        <tr>
                                            <th>Eindterm</th>
                                            <th width="130">Competenties</th>
                                            <th width="130">{this.state.roles_are_editable ? "Status" : ""}</th>
                                        </tr>
                                    </thead>
                                    <tbody>{endtermRows}</tbody>
                                </table>

                                <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />
                            </div>
                        </div>

                        <div className="form-group text-center">
                            <Link className="btn btn-light" to={"/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments"}>
                                Terug naar het overzicht
                            </Link>
                            <button className="btn btn-primary" type="submit">
                                Opslaan
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
